import { navigate } from 'gatsby';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { InfoH2, TitleH2 } from '../HealthSummary.style';
import {
  ApprovedDiv,
  Approvedh2,
  InfoSection,
  YesOrNo,
} from './DirectivesEntry.style';

const messages = defineMessages({
  unknown: {
    id: 'GLOBAL.unknown',
    defaultMessage: 'Unknown',
  },
});

function DirectivesEntry({
  data = [],
  clickable = true,
  route = '',
  subtitle = '',
  title = '',
}: {
  data: React.ReactNode[];
  clickable: boolean;
  route: string;
  subtitle?: string;
  title: string;
}) {
  const { formatMessage } = useIntl();
  return (
    <InfoSection
      clickable={clickable}
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      onClick={() => clickable && route && navigate(route)}
    >
      <TitleH2>{title}</TitleH2>
      {data instanceof Array && data.length > 0 ? (
        <div>
          <ApprovedDiv>
            <Approvedh2>{subtitle}</Approvedh2>
            {data.map((dat, index) => (
              <InfoH2 key={index}>{dat}</InfoH2>
            ))}
          </ApprovedDiv>
        </div>
      ) : (
        <YesOrNo>{formatMessage(messages.unknown)}</YesOrNo>
      )}
    </InfoSection>
  );
}

export default DirectivesEntry;
